import { INavItem, NavItem } from "./nav-item";
import { Environment } from "@front/m19-models/M19Environment";

export const dashboardMenu: INavItem = {
  label: "page-title.dashboard",
  id: "dashboard",
  children: [
    {
      icon: "home",
      label: "page-title.home",
      url: "/dashboard/home",
      id: "dashboard-home",
    },
    {
      icon: "layoutDashboard",
      label: "page-title.account_360",
      url: "/dashboard/account360",
      id: "dashboard-account360",
    },
    {
      icon: "lineChart",
      label: "page-title.advertising",
      url: "/dashboard/advertising",
      id: "dashboard-advertising",
    },
    {
      icon: "dollarSign",
      label: "page-title.profit_and_loss",
      url: "/dashboard/profit-and-loss",
      id: "dashboard-profit-and-loss",
    },
  ],
};

export const advertisingMenu: INavItem = {
  label: "page-title.advertising",
  id: "advertising",
  children: [
    {
      icon: "lightbulb",
      label: "common.strategies",
      id: "strategies",
      children: [
        {
          label: "page-title.sp",
          url: "/advertising/sponsored-product",
          id: "sponsored-product",
        },
        {
          label: "page-title.sb",
          url: "/advertising/sponsored-brands",
          id: "sponsored-brands",
        },
        {
          label: "page-title.sd",
          url: "/advertising/sponsored-display",
          id: "sponsored-display",
        },
        {
          label: "page-title.dsp",
          url: "/advertising/dsp/strategies",
          id: "dsp-strategies",
        },
        {
          label: "metrics.TACOS_title",
          url: "/advertising/tacos-strategies",
          id: "tacos",
        },
      ],
    },
    {
      label: "page-title.dsp",
      icon: "globe",
      url: "/advertising/dsp/stats",
      id: "dsp",
    },
    {
      label: "page-title.dsp_product_audiences",
      icon: "usersRound",
      url: "/advertising/dsp/audiences",
      id: "dsp-audiences",
    },
    {
      label: "page-title.amc",
      icon: "cloud",
      url: "/advertising/amc",
      id: "amc",
    },
    {
      label: "page-title.more",
      id: "advertising-more",
      icon: "ellipsis",
      children: [
        {
          label: "page-title.hourly_stats",
          url: "/advertising/hourly-stats",
          id: "hourly-stats",
        },
        {
          label: "page-title.promo_days_boost",
          url: "/advertising/promo-days-boost",
          id: "promo-day",
        },
      ],
    },
  ],
};

export const productMenu: INavItem = {
  label: "page-title.product_center",
  id: "product-center",
  children: [
    {
      label: "page-title.product_analysis",
      icon: "search",
      url: "/product-center/product-analysis",
      id: "product-analysis",
    },
    {
      label: "page-title.catalog",
      icon: "bookOpen",
      url: "/product-center/catalog",
      id: "catalog",
    },
    {
      label: "page-title.inventory",
      url: "/product-center/inventory",
      id: "inventory",
      icon: "box",
    },
    {
      label: "page-title.more",
      id: "product-more",
      icon: "ellipsis",
      children: [
        {
          label: "page-title.product_360",
          url: "/product-center/product360",
          id: "product-360",
        },
        {
          label: "page-title.product_tracker",
          url: "/product-center/product-tracker",
          id: "product-tracker",
        },

        {
          label: "page-title.product_groups",
          url: "/product-center/product-group",
          id: "product-group",
        },
        {
          label: "page-title.brand_alias",
          url: "/product-center/brand-alias",
          id: "brand-alias",
        },
      ],
    },
  ],
};

export const keywordMenu: INavItem = {
  label: "page-title.keyword_center",
  id: "keyword-center",
  children: [
    {
      label: "page-title.traffic_analysis",
      icon: "mousePointerClick",
      url: "/keyword-center/traffic-analysis",
      id: "traffic-analysis",
    },
    {
      label: "page-title.keyword_tracker",
      icon: "chartNoAxesColumn",
      url: "/keyword-center/keyword-tracker",
      id: "keyword-tracker",
    },
    {
      label: "page-title.more",
      id: "keyword-more",
      icon: "ellipsis",
      children: [
        {
          label: "page-title.share_of_voice",
          url: "/keyword-center/share-of-voice",
          id: "share-of-voice",
        },
        // {
        //   label: "page-title.search_trends",
        //   url: "/keyword-center/search-trends",
        //   id: "search-trends",
        // },
        {
          label: "page-title.segments",
          url: "/keyword-center/segments",
          id: "segments",
        },
      ],
    },
  ],
};
export class SidebarItemFactory {
  private items: INavItem[] = [];

  constructor(items: INavItem[] = [dashboardMenu, advertisingMenu, productMenu, keywordMenu]) {
    this.items = items;
  }

  getNavItems(isBetaTester: boolean, isAdminLogin: boolean, environment: Environment): NavItem[] {
    return this.items.map((section) => {
      section.children = section.children?.filter((item) =>
        this.itemShouldBeDisplayed(item, isBetaTester, isAdminLogin, environment),
      );
      return new NavItem(section);
    });
  }

  private itemShouldBeDisplayed(
    item: INavItem,
    isBetaTester: boolean,
    isAdminLogin: boolean,
    environment: Environment,
  ): boolean {
    if (item.onlyBeta && !isBetaTester) return false;
    if (item.onlyAdmin && !isAdminLogin) return false;

    const isEnvironmentMatching = item.environment === environment;

    return !(item.environment && !isEnvironmentMatching);
  }
}

export { findBestMatchingNavItem } from "@front/m19-ui";
